import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";
import {
    type Choice,
    ConfigurationTab,
    type FilterOption,
    FilterType,
    type ProductPropertyKey,
} from "@/features/sub-families/types";
import { getDimmingTypeOptions, getSupplyOptions } from "@/features/sub-families/utils/power-supply-dimming-type.ts";
import type { TranslationKey } from "@/features/translations/types";
import { useAppSelector } from "@/redux/store.ts";
import { type LooseAutocomplete, SmartNumberDescriptor, type SmartNumberDescriptorKey } from "@/types";

export default function usePowerSupplyDimmingTypeFilterOptions() {
    const currentProduct = useCurrentProduct();

    const products = useAppSelector((state) => state.products.items);

    return (property: Extract<ProductPropertyKey, "supply" | "dimming_type">) => {
        switch (property) {
            case "supply": {
                const choices = getSupplyOptions(currentProduct);
                return createFilterOption("dimming_type", SmartNumberDescriptor.DimType, choices);
            }

            case "dimming_type": {
                const choices = getDimmingTypeOptions(products);
                return createFilterOption("dimming_type", SmartNumberDescriptor.DimType, choices);
            }

            default:
                return null;
        }
    };
}

function createFilterOption(
    label: LooseAutocomplete<TranslationKey>,
    descriptor: SmartNumberDescriptorKey,
    choices: Choice[],
): FilterOption {
    return {
        label,
        descriptor,
        choices,
        filterType: FilterType.Radio,
        tab: ConfigurationTab.Light,
        sortKey: null,
    };
}
